import { parseDateForDb, parseZoopDate } from 'utils/parsers';

interface IUserInfoZoopConverted {
  gender: string;
  birthday: string;
  registration_district: string;
  registration_address_state: string;
  registration_pin_code: string;
  registration_house: string;
  registration_street: string;
  registration_locality: string;
  registration_post_office: string;
  registration_address: string;
}

interface IUserInfoZoop {
  address: string;
  district: string;
  dob: string;
  gender: string;
  house: string;
  locality: string;
  pin_code: string;
  post_office: string;
  state: string;
  street: string;
}

export const getUserInfoZoop = (userInfo: IUserInfoZoop): IUserInfoZoopConverted => {
  const { address, district, dob, gender, house, locality, pin_code, post_office, state, street } =
    userInfo;

  return {
    gender: gender === 'F' ? 'female' : 'male',
    birthday: parseDateForDb(parseZoopDate(dob)),
    registration_district: district,
    registration_address_state: state,
    registration_pin_code: pin_code,
    registration_house: house,
    registration_street: street,
    registration_locality: locality,
    registration_post_office: post_office,
    registration_address: address,
  };
};
